module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "dedicationPage_01"
    }
  }, [_c('p', {
    staticClass: "dedicationHead"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("For")])])])]), _c('p', {
    staticClass: "dedicationHead"
  }, [_c('span', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USANNE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRK")])])]), _c('p', {
    staticClass: "dedicationText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Brilliant editor, devoted friend,"), _c('br'), _vm._v("\ncrime fiction scholar")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b55bcec0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780743250702_dedicationPage_01.vue
// module id = 66
// module chunks = 0